import { HeadCell } from "../../../../shared/components/enhanced-table-head/enhanced-table-head";
import { ColumnName } from "../enums/column-name";
import { AssetUsageRecord } from "../models/asset-usage-record";

export const assetUsageRecordColumnLabels: HeadCell<keyof AssetUsageRecord>[] = [
  { id: ColumnName.FarmLandName, label: "Номер поля", width: 120 },
  { id: ColumnName.DateCreated, label: "Дата работы", width: 90 },
  { id: ColumnName.TechOperationSubGroupName, label: "Подгруппа ТО", width: 220 },
  {
    id: ColumnName.PersonCreatedName,
    label: "Пользователь",
    width: 140,
  },
  { id: ColumnName.PersonResponsibleName, label: "МОЛ", width: 140 },
  { id: ColumnName.AssetType, label: "Вид ТМЦ", width: 100 },
  { id: ColumnName.AssetName, label: "ТМЦ", width: 300 },
  { id: ColumnName.Quantity, label: "Количество ТМЦ", width: 160 },
  { id: ColumnName.FieldSize, label: "Площадь", width: 90 },
  { id: ColumnName.Norma, label: "Норма", width: 90 },
  { id: ColumnName.CropTypeName, label: "Культура", width: 240 },
  { id: ColumnName.Status, label: "Статус", width: 85 },
  { id: ColumnName.Comment, label: "Комментарий", width: 85 },
];
